import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CrmApiService } from '@shared/core';
import { BackendApiResponse, EntityId } from '@shared/core/types';
import { convertApiItemResponseToItem } from '@shared/core/utils';
import {
  EducationService,
  EducationServiceKit,
  ProductsForMutationResponse,
  TariffListByKitCodeResponse,
} from '@crm/shared/persons/types';

@Injectable({
  providedIn: 'root',
})
export class EducationServiceApiSharedService extends CrmApiService {
  getGeneral(personId: EntityId, educationServiceId: EntityId): Observable<EducationService> {
    const url = `${this.baseEndpoint}students/${personId}/education-services/${educationServiceId}/general/`;
    return this.api.get<BackendApiResponse<EducationService>>(url).pipe(
      convertApiItemResponseToItem,
      catchError(() => of(null)),
    );
  }

  loadServiceKit(educationServiceId: EntityId): Observable<EducationServiceKit> {
    const url = `${this.baseEndpoint}v1/education-service-kits/${educationServiceId}/`;

    return this.api.get<BackendApiResponse<EducationServiceKit>>(url).pipe(
      convertApiItemResponseToItem,
      catchError(() => of(null)),
    );
  }

  getProductsForMutation(educationServiceId: EntityId): Observable<ProductsForMutationResponse> {
    const url = `${this.c1Host}api/v1/admin/crm2/education-service/get-products-for-mutation`;

    return this.api
      .get<ProductsForMutationResponse>(url, {
        params: {
          education_service_id: educationServiceId,
        },
      })
      .pipe(catchError(() => of(null)));
  }

  getTariffListByKitCode(productKitCode: EntityId): Observable<TariffListByKitCodeResponse> {
    const url = `${this.c1Host}api/v1/admin/crm2/education-service/get-tariff-list-by-kit-code`;

    return this.api
      .get<TariffListByKitCodeResponse>(url, {
        params: {
          product_kit_code: productKitCode,
        },
      })
      .pipe(catchError(() => of(null)));
  }
}
